import Incidents from "../../../utils/services/project/metering/incidentsService";
import crudTemplate from "../../../templates/crudTemplate";
import i18n from "../../../../plugins/i18n";
let crud = crudTemplate(Incidents);

function prepareItem(i) {
  return {
    ...i,
    level: i18n.t("incidents.levels." + i.level),
    _incidentable: transformIncidentable(i._incidentable)
  };
}

function transformIncidentable(incidentable) {
  if (incidentable === null) {
    return { name: "Unknown" };
  }

  incidentable.name = incidentable.instance.name;

  switch (incidentable.type) {
    case "MeterUnitTariff":
      incidentable.to = "meter-unit";
      incidentable.id = incidentable.instance._meter_unit.id;
      incidentable.name =
        incidentable.instance._meter_unit.name +
        "→" +
        incidentable.instance._tariff.name;
      break;
    case "MeterUnit":
      incidentable.to = "meter-unit";
      break;
    case "Source":
      incidentable.to = "source";
      break;
  }

  return incidentable;
}

const state = {
  ...crud.state
};
const getters = {
  ...crud.getters,
  getList(state) {
    let list = crud.getters.getList(state);
    return list.map(prepareItem);
  }
};

const actions = {
  ...crud.actions
};

const mutations = {
  ...crud.mutations
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
